import React, { PropsWithChildren } from "react";
import {BrowserRouter} from "react-router-dom";

import Routes from "routes/Router";

export default function RouteProvider({ children }: PropsWithChildren) {
  return (
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  );
}
